// @ts-nocheck
import Paper from 'paper';
import { ImageSharedModels } from '@medsurf/flat-models';
import { Container } from '../container';
import { Sprite } from './sprite';

/**
 * Virtual pointer class
 */
export class VirtualPointer extends Sprite<ImageSharedModels.VirtualPointerModel> {
  /**
   * Members
   */
  private _isMovable: boolean;

  /**
   * Constructor
   *
   * @param http
   * @param localPaper
   * @param mainLayer
   * @param container
   */
  public constructor(localPaper: Paper.PaperScope,
                     mainLayer: Paper.Layer,
                     container: Container) {
    const model = {
      offset: {
        x: (container.getCanvasSize().width / 2),
        y: (container.getCanvasSize().height / 2)
      },
      scale: 1
    };

    if (model.scale <= 0.1) {
      model.scale = 0.1;
    }

    super(model, localPaper, mainLayer, container);
    this._isMovable = true;
  }

  /**
   * Set file to load
   */
  public loadFile(): void {
    const url = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI0Ny44NyIgaGVpZ2h0PSI4NC4xODciIHZpZXdCb3g9IjAgMCAxMi42NjYgMjIuMjc1Ij4KICA8ZGVmcz4KICAgIDxmaWx0ZXIgaWQ9ImEiIHdpZHRoPSIxLjE0OSIgaGVpZ2h0PSIxLjA4MSIgeD0iLS4wNzUiIHk9Ii0uMDQiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CiAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249Ii4zNDIiLz4KICAgIDwvZmlsdGVyPgogIDwvZGVmcz4KICA8cGF0aCBmaWxsLW9wYWNpdHk9Ii43IiBkPSJNLjkxNiAxLjI0NHYxNC42NmwzLjAzNy0yLjU0NiAzLjM2MyA4LjE2MiAzLjE2Ny0xLjUwMi0zLjIzMy03Ljc3aDQuNjd6IiBmaWx0ZXI9InVybCgjYSkiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTpub3JtYWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMDc1IC0uMDY2KSIvPgogIDxwYXRoIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIuMjY1IiBkPSJNLjEzMi4zMnYxNC42NmwzLjAzNy0yLjU0NyAzLjM2MyA4LjE2MyAzLjE2Ny0xLjUwMi0zLjIzMi03Ljc3MWg0LjY2OVoiLz4KPC9zdmc+'
    this.doLoadFile(url);
  }

  /**
   * Arrange
   */
  public arrange(): void {
    super.arrange();
    if (this._image) {
      this._image.setScaling(1 / this._image.view.zoom * this.model.scale);
    }
  }

  /**
   * Setter Movable
   *
   * @param id
   */
  public set isMovable(id: boolean) {
    this._isMovable = id;
  }

  /**
   * Getter Movable
   *
   * @returns {boolean}
   */
  public get isMovable(): boolean {
    return this._isMovable;
  }
}
